import api from "../../../../../api";

export const requestGetCars = () => api.get("/carsuser");

export const requestGetCar = (id) => api.get(`/usercar/${id}`)

export const requestGetActiveRequests = (id) => api.get(`/partrequest/by-car/${id}`);

export const requestGetUnActiveRequests = (props) => {

    let url = `/partrequest/unactive/by-car`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const requestGetSingleRequest = (id) => api.get(`/partrequest/${id}`)


export const requestGetPartOffers = (props) => {

    let url = `/partoffer/by-part-request/paginated`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const createUserCar = (props) => api.post('/usercar', props, { "Content-Type": "multipart/form-data" });